import React, { useState } from 'react';
import socket from '../../utils/socket';
import { useAuthContext } from '../../context/AuthContextProvider';
import './MessageInput.css';
import axiosInstance from '../../axiosapi';
import { debounce } from '../../utils/debounce';

const SendMessageForm = ({ selectedTeacher, handleSuccess }) => {
  const { currentUser } = useAuthContext();
  const [newMessage, setNewMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const serverUrl = process.env.REACT_APP_SERVER_URL;

  const sendMessage = async () => {
    if (!newMessage.trim()) return;

    const messageData = {
      senderId: currentUser.id,
      receiverId: selectedTeacher.id,
      content: newMessage,
    };

    // Save message to the database
    await axiosInstance
      .post(`${serverUrl}/api/v1/messages`, messageData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((res) => {
        // Emit the message to the server
        socket.emit('sendMessage', messageData, (ack) => {
          console.log('Acknowledgment from server:', ack);
        });

        // Update UI immediately
        handleSuccess(res.data);
        setNewMessage('');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const emitTyping = debounce(() => {
    if (socket && selectedTeacher) {
      socket.emit('typing', {
        senderId: currentUser.id,
        receiverId: selectedTeacher.userId,
        username: currentUser.first_name,
        typing: true,
      });
    }
  }, 500);

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
    emitTyping();
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        sendMessage();
      }}
    >
      <div className="message-input-container">
        <div className="input-section">
          {/* <label htmlFor="file" className="file-upload-label">
            {watch("document")?.length > 0 ? (
              <FaCircleCheck className="upload-icon uploaded" />
            ) : (
              <IoMdCloudUpload className="upload-icon" />
            )}
          </label>
          <input
            type="file"
            id="file"
            className="hidden-input"
            {...register("document")}
          /> */}
          <input
            type="text"
            className="message-input"
            placeholder="Enter a message"
            value={newMessage}
            onChange={handleInputChange}
          />
        </div>
        <button type="submit" className="send-button">
          {isLoading ? 'Sending...' : 'Send'}
        </button>
      </div>
    </form>
  );
};

export default SendMessageForm;
